import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { heroContentService, HeroContent } from '../../../services/hero';

const HeroBanner: React.FC = () => {
  const navigate = useNavigate();
  const [heroContent, setHeroContent] = useState<HeroContent | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchHeroContent = async () => {
      try {
        const contents = await heroContentService.getHeroContent();
        // Typically, you might want the most recent or a featured hero content
        if (contents.length > 0) {
          setHeroContent(contents[0]);
        }
        setIsLoading(false);
      } catch (err) {
        setError('Failed to load hero content');
        setIsLoading(false);
      }
    };

    fetchHeroContent();
  }, []);

  const handleExploreClick = () => {
    navigate('/layanan/produk-layanan');
  };

  if (isLoading) {
    return (
      <div className="bg-white p-8 md:p-16 pt-24 md:pt-16 mt-10 relative overflow-hidden">
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white p-8 md:p-16 pt-24 md:pt-16 mt-10 relative overflow-hidden">
        {error}
      </div>
    );
  }

  if (!heroContent) {
    return null;
  }

  return (
    <div className="bg-white p-8 md:p-16 pt-24 md:pt-16 mt-10 relative overflow-hidden">
      {/* Background circle patterns */}
      <div className="absolute top-0 right-0 w-48 h-48 rounded-full border-8 border-lime-100 -mr-24 -mt-24" />
      <div className="absolute top-4 right-4 w-32 h-32 rounded-full border-4 border-lime-200" />

      <div className="container mx-auto flex flex-col md:flex-row items-center relative">
        <div className="md:w-1/2 mb-8 md:mb-0">
          <h1 className="text-4xl md:text-5xl font-bold text-lime-600 mb-4">
            {heroContent.title}
          </h1>
          <div 
            className="text-gray-600 mb-6"
            dangerouslySetInnerHTML={{ 
              __html: heroContent.description 
            }} 
          />
          <button 
            onClick={handleExploreClick}
            className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 rounded-xl"
          >
            Eksplor kesehatan jamu
          </button>
        </div>
        <div className="md:w-1/2 relative flex justify-center items-center">
          <div className="relative w-96 h-96">
            <div className="absolute inset-6 rounded-full overflow-hidden border-4 border-white shadow-lg">
              <img
                src={`${process.env.REACT_APP_API_URL}${heroContent.image}`}
                alt={heroContent.title}
                className="absolute w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;